import React from "react";
import "./styles/community.css";
import Navbar from "../../components/navbar/navbar";
import Runnersgroup from "../../assets/icons/RunnersGroup.svg";
import ComnmunitiesAndEvents from "./ComunitiesAndEvents";
import Footer from "../../components/footer/Footer";
import GroupRunner from "../../assets/images/communitiesLanding.jpg";
import ScrollAnimation from "react-animate-on-scroll";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";

const Community = () => {
  const { userType } = useSelector((state) => state.userReducer);
  const { isAuthenticated } = useSelector((state) => state.authReducer);
  const navigation = useNavigate();
  const onClick = () => {
    if (isAuthenticated) {
      if (userType === "user") {
        navigation("/dashboard/history");
      } else {
        toast.error(
          "¡Debes iniciar sesión como Runner para acceder a esta sección!"
        );
      }
    } else {
      navigation("/auth");
    }
  };
  return (
    <section className="wraper-community">
      <div className="hero-community">
        <Navbar page={"community"} />
        <div className="wraper-title-community">
          <h1 className="text-white text-center">
            <strong className="text-secondary">Radaria</strong> una comunidad
            unida.
          </h1>
          <img src={Runnersgroup} alt="runners" />
        </div>
      </div>
      <section className="wrap-description-community">
        <div>
          <div className="container-tile-service">
            <div></div>
            <h2 className="text-white text-center">Comunidad de Radaria</h2>
            <div></div>
          </div>
          <p className="text-white text-center fs-5">
            Bienvenido a la comunidad que corre contigo. En Radaria, no corres
            solo, aquí encontrarás corredores que comparten tu pasión, te
            motivan y te inspiran a seguir adelante. Porque correr juntos
            siempre es mejor.
          </p>
        </div>
      </section>
      <section className="wrap-join-community">
        <div className="subwrap-joinCommunity">
          <div className="d-flex flex-column align-items-center">
            <p className="text-white text-center fs-5 text-community-dec">
              La carrera más importante no es contra los demás, sino contigo
              mismo. Pero, ¿sabes qué? ¡No tienes que enfrentarla solo!
            </p>
            <button
              onClick={onClick}
              className={`btn button-link ${`btn-primary active animate__animated animate__pulse animate__infinite infinite `}  m-2 ps-4 pe-4 `}
            >
              ¡Vamos!
            </button>
          </div>
        </div>
        <ScrollAnimation
          animateIn="fadeIn"
          animateOut="fadeOut"
          className="container-img-map "
          style={{ width: 350 }}
        >
          <img src={GroupRunner} alt="" style={{ borderRadius: 20 }} />
        </ScrollAnimation>
      </section>
      <section className="wrap-container-phrase-community">
        <h3 className="text-white text-center">
          En los clubs de corredores de Radaria, correr en comunidad nunca ha
          sido tan inspirador. Conecta, mejora y disfruta cada kilómetro
          acompañado.
        </h3>
      </section>
      <ComnmunitiesAndEvents />

      <Footer />
    </section>
  );
};

export default Community;
